import type { Maybe } from '../types';

import z from 'zod';

export function doubleKeySchema<Value extends z.core.SomeType>(value: Value) {
  return z.record(z.string(), z.record(z.string(), value));
}
export type DoubleKeyRecord<V> = Record<string, Record<string, V>>;

export function patchDoubleKeyRecord<V>(
  record: DoubleKeyRecord<V>,
  k1: string,
  k2: string,
  patch: Partial<V>,
) {
  if (!(k1 in record)) {
    record[k1] = {};
  }

  // triggers shallow record[k1][k2] watchers
  record[k1][k2] = {
    ...record[k1][k2],
    ...patch,
  };
}

export function deleteSecondKey<V>(record: DoubleKeyRecord<V>, k2: string) {
  Object.keys(record).forEach((k1) => {
    delete record[k1][k2];
  });
}

export function getDoubleKeyRecord<V>(
  record: DoubleKeyRecord<V>,
  k1: Maybe<string>,
  k2: Maybe<string>,
): Maybe<V> {
  if (k1 == null || k2 == null) return null;
  return record[k1]?.[k2];
}
